<template>
	<!-- 资料管理 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item v-if="bquery">
					<el-input v-model="filters.companyName" placeholder="企业名称"></el-input>
				</el-form-item>
        		<el-form-item>
					<el-input v-model="filters.fileName" placeholder="文件名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="companyFileList">查询</el-button>
				</el-form-item>
					<el-form-item v-if="bshow">
					<el-button type="success" v-on:click="handleAddbzhFile">新增文件</el-button>
				</el-form-item>
				<el-form-item v-if="bquery">
					<el-button type="warning" @click="handledc" :loading="dcLoading">导出</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="companyfilelist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="fileName" label="文件名称" min-width="220" align="center">
			</el-table-column>

			<el-table-column prop="fileTypeName" label="文件类型" align="center"  min-width="200">
			</el-table-column>

			<el-table-column prop="createTime" label="提交日期" align="center"  min-width="100">
		 	</el-table-column>

			<el-table-column prop="coName" label="所属企业"  align="center" min-width="150">
		 	</el-table-column>

			<el-table-column   label="操作"  align="left" width="250">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="handleFileShow(scope.$index, scope.row)">查看文件</el-button>
					<el-button v-if="bshow"  type="danger" size="small" @click="handleFileDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		
		<!--显示PDF-->
		<el-dialog :title="pdfFileName" v-model="pdfVisible" :close-on-click-modal="false" >
			<el-form>
				<iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 500px"></iframe>
			</el-form>
		</el-dialog>


		<!--新增文件-->
		<el-dialog title="新增文件" v-model="fileFormVisible" :close-on-click-modal="false" >
				<el-form :label-position="labelPosition" :model="fileForm" label-width="150px" :rules="fileFormRules" ref="fileForm">
					
					<el-form-item label="文件类型" >
						<el-select v-model="fileTypevalue" placeholder="请选择" style="width: 440px;">
							<el-option v-for="item in fileTypeoptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="上传文件" >
						<div>
							<input ref="upLoadRef" type="file" @change.stop="handleFileUpload"> <!-- .stop阻止冒泡 -->
							<button  v-show="uploadstart" @click.stop.prevent="uploadCompanyFile">上传</button> <!-- .stop阻止冒泡 .prevent阻止默认行为 -->
						</div>
					</el-form-item>

					<el-form-item label="文件名称" prop="fileName">
						<el-input placeholder="请输入文件名称" v-model="fileForm.fileName" auto-complete="off"></el-input>
					</el-form-item>

					<el-form-item label="年份" prop="fileNf">
						<el-input placeholder="请输入年份，比如2026年，就输入2026" v-model="fileForm.fileNf" auto-complete="off"></el-input>
					</el-form-item>

				</el-form>
						
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="fileFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="handlefile" :loading="fileLoading">保存</el-button>
			</div>
		</el-dialog>


	</section>
</template>

<script>
	import axios from 'axios';
	import { companyFilePageList,companyFilePageListdc,addCompanyFile,deletecompanyFile,getparamsByType} from '../../api/api';
	let moment = require("moment");
	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到
				coId:0, //当前登录的用户企业id

				bquery:false,//管理员权限
				bshow:false,//是否显示操作按钮

				filters: {
					companyName: '',
					fileName:''
				},
				companyfilelist: [],
				total: 0,
				page: 1,
				listLoading: false,

				fileTypeoptions: [],
				fileTypevalue:'',
			
				//新增文件
				labelPosition: 'right',

				imageFile: null,
			
				uploadstart:true,

				fileFormVisible: false, 
				fileLoading: false,
				fileFormRules: {
					fileName: [{ required: true, message: "请输入文件名称", trigger: "blur" }],
					fileNf: [{ required: true, message: "请输入年份数字", trigger: "blur" }],
				},
				
				fileForm: {
					createUserId:0,
					coId:0,

					uniqueCode:"",

					fileType:"",
					fileName:"",
					fileNf:"",
					fileUrl:"",		
				},

				// 显示pdf
				pdfVisible: false, 
				pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
				pdfFileName:"",
				// 正式地址
				filebaseurl:"https://aqjg.ycsyzglj.com/",

				//要导出的数据list
				exportList: [],
				dcLoading: false
				//end

			}
		},
		methods: {
	
			handleAddbzhFile: function () {
				this.fileFormVisible = true;
				this.uploadstart=true
				this.imageFile = null;

				this.fileForm.uniqueCode="yhpczl_"+this.objectId
				this.fileForm.createUserId=this.objectId
				this.fileForm.coId=this.coId
				this.fileForm.fileNf=""
				this.fileForm.fileName=""
				if (this.$refs.upLoadRef) {
					this.$refs.upLoadRef.value = '' // 置空input文件
				}
				
			},
			handleFileUpload(event) {
				let filearr = event.target.files[0].name.split('.');

				if(filearr[1]=='pdf'){
					this.fileForm.fileName=filearr[0]
					this.imageFile = event.target.files[0];
				}else{
					this.fileForm.fileName=""
					this.imageFile = null;
					this.$message.error("请选择pdf格式的文件");
				}
				
			},
			uploadCompanyFile() {
				if(this.imageFile!=null){
					let formData = new FormData();
					formData.append('file', this.imageFile);
					formData.append('filetype', "Yhpczl");
					formData.append('secondarydir', this.fileForm.uniqueCode);
					axios.post('/yhpczl/mgr/v1/uploadFile', formData, {
						headers: {
						'Content-Type': 'multipart/form-data'
						}
					}).then(response => {					
						if (response.data.code==0) {
							this.fileForm.fileUrl = response.data.data.url;
							this.uploadstart=false
							this.$message.success("文件上传成功，请填写其他信息后点击保存");
						} else {
							this.$message.error("文件上传失败，请重新提交");
						}
					});
				}else{
					this.$message.error("请选择文件后再点击【上传】按钮");
				}
				
			},
			handlefile: function () {
				if(this.fileForm.fileUrl!=""){
					this.$refs.fileForm.validate((valid) => {
						if (valid) {
							this.$confirm('确认提交文件吗？', '提示', {}).then(() => {
							this.fileLoading = true;

							this.fileForm.fileType=this.fileTypevalue

							addCompanyFile(this.fileForm).then((res) => {
									this.fileLoading = false;

									this.fileFormVisible = false;
									if(res.data.code==0){
										this.$message.success(res.data.message);
										//更新列表
										this.companyFileList();
									}
									else{
										this.$message.error(res.data.message);
									}
								});
							});
						}
					});
				}
				else{
					this.$message.error("请选择文件后，点击右侧的【上传】按钮，上传文件");
				}

			},	
			handleFileShow: function (index, row) {
				this.pdfSrc=this.filebaseurl+row.fileUrl
				this.pdfFileName=row.fileName
				this.pdfVisible=true
			},
			handleFileDel: function (index, row) {
				this.$confirm('确认删除这个文件吗？', '提示', {}).then(() => {
					let deleteparam={
						fileId:row.fileId
					}
					deletecompanyFile(deleteparam).then((res) => {
						if(res.data.code==0){
							this.$message.success(res.data.message);
							this.companyFileList();
						}
						else{
							this.$message.error(res.data.message);
						}
					});
				});	
			},

			handleCurrentChange(val) {				
				this.page = val;
				this.companyFileList();
			},
			//获取文件列表
			companyFileList() {
				let para = {
					page: this.page,
					pageSize:20,
					coName: this.filters.companyName,
					coId:this.coId,
					objectId:this.objectId,
					fileName: this.filters.fileName
				};

				this.listLoading = true;

				companyFilePageList(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.companyfilelist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			getWJLXdic() {
				let para={
					MpType:"WJLX",
					MpParentId:"26"
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.fileTypeoptions  =res.data.data
						this.fileTypevalue=this.fileTypeoptions[0].MpValue
					}
				});
			},
			//导出excel
			handledc: function() {

				this.$confirm('确认导出文件表吗？', '提示', {}).then(() => {
					let para = {
						coName: this.filters.companyName,
						coId:this.coId,
						objectId:this.objectId,
						fileName: this.filters.fileName
					};

					this.dcLoading = true;

					companyFilePageListdc(para).then(res => {
						this.dcLoading = false;
						if (res.data.code == 0) {
							// 循环处理每一项url
							let datalist = res.data.data;
							datalist.forEach(item => {
								// 如果 item 本身有 url，就拼接 https
								if (item.fileUrl) {
									item.pdfsrc =  this.filebaseurl + item.fileUrl;
								} 
							});
							//将data数据赋给exportList这个列表，用于当作导出Excel的数据源							
							this.exportList = datalist;

							//开始执行导出方法，此方法要放在括号里面，因为是异步请求数据，请求完才能执行导出
							this.export2Excel();
						} 
						else {
							this.$message.error(res.data.message);
						}
					});
					
				}).catch(() => {
  					// 用户点了取消 → 必须写 catch，否则控制台报错
					// this.$message.info('已取消');
				});			
			},

			export2Excel() {
			require.ensure([], () => {
				const { export_json_to_excel } = require("@/vendor/Export2Excel");

				const tHeader = [
				"所属企业",
				"文件名称",
				"文件类型",
				"提交日期",
				"文件地址",

				];

				const filterVal = [
				"coName",
				"fileName",
				"fileTypeName",
				"createTime",
				"pdfsrc"
				
				];

				const list = this.exportList;

				const data = this.formatJson(filterVal, list);

				export_json_to_excel(
					tHeader,
					data,
					"资料表_" + moment(new Date()).format("YYYYMMDDHHmmss")
				);
			});
			},

			formatJson(filterVal, jsonData) {
			return jsonData.map(v => filterVal.map(j => v[j]));
			},
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));

			this.coId = user.data.coId
			this.objectId = user.data.userId

			if (user.data.roleId=="4") {
				this.filters.companyName = user.data.userName	
				this.bshow=true
				this.bquery=false
			} else {
				this.bquery=true
				this.bshow=false
			}

			this.companyFileList();
			this.getWJLXdic();

		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// enterpriseFile.vue?765c7edc